<script>
  import SingleDatePicker from "@shared/svelte/Components/SingleDatePicker.svelte";
  import moment from "moment";
  export let availableDates;
  // dates represents the set of delivery dates that are considered appropriate for this retailer
  export let dates;
  export let selectedDate;
  export let routes;
  export let integratedDelivery;
  export let handleIntegratedDateSelect;
  export let handleDateSelect;

  let position = "";

  $: notInRoute = !dates.find(function (x) {
    return x.date == selectedDate;
  });

  function dateOptionText(date) {
    return (
      moment(date.date).format("ddd, MMM D") +
      (date.holiday ? " - Holiday Alert" : "") +
      (date.integrated ? " *" : "")
    ).trim();
  }

  function setDate(date) {
    return date ? moment(date).format("YYYY-MM-DD").toString() : null;
  }

  function selectDateWrapper(date) {
    handleDateSelect(setDate(date), false);
  }

</script>

{#if integratedDelivery}
  <div class="dates-wrapper">
    <!-- svelte-ignore a11y-no-onchange -->
    <select
      class="fizz-select fizz-stack-8 full-width"
      name="Select delivery date"
      value={selectedDate || ""}
      on:change={handleIntegratedDateSelect}
    >
      {#if !selectedDate}
        <option value="">Select delivery date</option>
      {/if}
      {#each availableDates as date}
        <option value={date.date} key={date.date}>
          {dateOptionText(date)}
        </option>
      {/each}
    </select>

    {#if routes && routes.length > 0}
      <p class="align-right fizz-text-small">
        {#if notInRoute}
          This is an Off-Day Delivery Route
        {:else if routes.length > 1}
          Regular Routes: {routes.join(", ")}
        {:else}
          Regular Route {routes[0]}
        {/if}
      </p>
    {/if}
  </div>
{:else}
  <SingleDatePicker
    bind:startDate={selectedDate}
    defaultButtonLabel={"Select a date"}
    minWidth={"210px"}
    dateFormat={"YYYY-MM-DD"}
    altButtonFormat={"ddd MMM D"}
    iconType={"ArrowDown"}
    iconSize={"16"}
    buttonMode={true}
    {position}
    selectDateCallback={selectDateWrapper}
    minDate={new Date(Date.now() - 86400000)}
  />
{/if}
